<app-loader *ngIf="isDisabled"></app-loader>
<div>
	<div class="row m-0">
		<div class="col"></div>
		<div class="col-auto">
			<button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
				[routerLink]="['/setting/leavepolicies/add/',0]" [disabled]="isDisabled">
				<i class="bi  bi-calendar2-range" *ngIf="!isDisabled"></i>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
					*ngIf="isDisabled"></span>
				{{!isDisabled?'Add Leave Policy':'Loading...'}}
			</button>
		</div>
	</div>
	<div class="card border-radius-0 mt-1 p-0">
		<div class="card-header">
			Leave Policies
		</div>
		<div class="card-body p-1">
			<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
				class="customeDatatable table table-bordered">
				<thead class="table-light">
					<tr>
						<th scope="col" style="width: 5px;">#</th>
						<th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
						<th>Policy Name</th>
						<th style="width: 80px;">Applicability</th>
						<!-- <th style="width: 80px;">Dual Applicability</th> -->
						<th style="width: 80px;">Leave</th>
						<!-- <th>Gender</th> -->
						<th style="width: 80px;">Emp Type</th>
						<!-- <th>IsAccural</th> -->
						<!-- <th style="width: 100px;">Default Policy</th> -->

					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let TableData of TableDatas; let i = index">
						<th scope="row" style="width: 5px;">{{i+1}}</th>
						<td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
							<div class="text-center"><i
									[routerLink]="['/setting/leavepolicies/add/',TableData['ESS_LeaveRuleID']]"
									class="bi bi-pencil-square text-warning"></i></div>
						</td>
						<td style="width: 150px;">{{TableData['LeaveRuleName']}}</td>
						<td style="width: 80px;">{{TableData['WebESSApplicability']}}</td>
						<!-- <td style="width: 80px;">{{TableData['WebESSApplicability2'] == null ? 'None': TableData['WebESSApplicability2']}}</td> -->
						<td style="width: 80px;">{{TableData['LeaveName']}}</td>
						<!-- <td>{{TableData['Gender']}}</td> -->
						<td style="width: 80px;">{{TableData['EmpType']}}</td>
						<!-- <td>{{TableData['IsAccural']?'Yes':'No'}}</td> -->
						<!-- <td style="width: 100px;">{{TableData['DefaultLeave']?'Yes':'No'}}</td> -->
					</tr>
				</tbody>
			</table>
		</div>
		<div class="card-footer">
			<div class="row">
				<div class="col">

					<div class="row">
					</div>
					<div class="row">
					</div>
				</div>
				<div class="col-auto">
					<button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
						(click)="exportToExcel()">
						<i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
						<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
							*ngIf="isDisabled"></span>
						{{!isDisabled?'Excel':'Loading...'}}
					</button>
				</div>
			</div>
		</div>

	</div>
</div>